import { CommonModule } from '@angular/common';
import { Component, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

declare global {
  interface Window {
    google: any;
  }
}

@Component({
  selector: 'app-google-signin',
  templateUrl: './google-signin.component.html',
  styleUrls: ['./google-signin.component.scss'],

  imports: [CommonModule, TranslateModule],
})
export class GoogleSigninComponent {
  loginWithGoogle = output<any>();

  /**
   * Creates a fake Google wrapper for custom styling and handling of Google Sign-In button.
   * @returns An object with a click method to trigger the Google Sign-In flow.
   */
  createFakeGoogleWrapper = () => {
    const googleLoginWrapper = document.createElement('div');
    googleLoginWrapper.style.display = 'none';
    googleLoginWrapper.classList.add('custom-google-button');
    document.body.appendChild(googleLoginWrapper);
    window.google.accounts.id.renderButton(googleLoginWrapper, {
      type: 'icon',
      width: '200',
    });

    const googleLoginWrapperButton = googleLoginWrapper.querySelector('div[role=button]') as HTMLElement;

    return {
      click: () => {
        googleLoginWrapperButton?.click();
      },
    };
  };

  /**
   * Handles the Google login process by emitting the fake Google wrapper.
   */
  handleGoogleLogin() {
    this.loginWithGoogle.emit(this.createFakeGoogleWrapper());
  }
}
